<template>
  <div>
    <p>
      Aplikasi masjed.id adalah sebuah aplikasi di bawah naungan PT MASJED
      INDONESIA DIGITAL (Penyedia Aplikasi) yang bergerak di bidang layanan
      sosial berbasis teknologi. Aplikasi masjed.id hadir untuk memudahkan dalam
      pengelolaan manajemen masjed dan manajemen ZISWAF dalam upaya pemberdayaan
      ekonomi dan layanan kepada masyarakat di lingkungan masjed. Selain itu,
      aplikasi masjed.id menghadirkan banyak fitur bermanfaat, guna memudahkan
      dalam pembuatan laporan pertanggungjawaban keuangan masjed, memperluas
      jaringan donasi dan kampanye pendanaan melalui fitur Pembayaran secara
      online, sehingga masjed mendapatkan santunan penyaluran Zakat, Infaq,
      Sedekah, dan Wakaf yang dapat dirasakan langsung oleh masyarakat yang
      membutuhkan melalui fitur Daftarkan Dhuafa. Selain itu masjed.id mendorong
      kegiatan pemberdayaan ekonomi melalui kegiatan usaha serambi masjed, yang
      dapat membantu meningkatkan kesejahteraan pengurus masjed dan
      lingkungannya. Aplikasi masjed.id ini tidak terafiliasi pada suatu
      organisasi, partai politik maupun kelompok manapun. Aplikasi masjed.id
      semata-mata dikembangkan untuk mendampingi ibadah umat muslim di
      Indonesia.
    </p>
    <p>
      Kebijakan Privasi yang terdapat dalam halaman ini mengatur hal-hal
      menyangkut data Pengguna Aplikasi (Informasi Pribadi) yang diberikan
      kepada Penyedia Aplikasi dalam rangka pemanfaatan fasilitas, fitur, jasa,
      dan/atau layanan yang ditawarkan Penyedia Aplikasi melalui aplikasi
      masjed.id. Pada saat mengunduh, mengakses, dan menggunakan aplikasi ini,
      maka Anda dianggap telah memberikan Informasi Pribadi Anda, dan menyetujui
      pengelolaan dan pengiriman Informasi Pribadi Anda serta mengikatkan diri
      pada seluruh syarat dan ketentuan dalam Kebijakan Privasi ini.
    </p>
    <p>
      Untuk meningkatkan pelayanan kepada Anda, kami akan memperbarui Kebijakan
      Privasi ini dari waktu ke waktu. Kami menyarankan Anda untuk secara
      teratur mereview aplikasi ini agar Anda mengetahui pembaharuan-pembaharuan
      yang terjadi pada Kebijakan Privasi ini.
    </p>
    <p>
      Syarat dan Ketentuan yang terdapat dalam Kebijakan Privasi ini merupakan
      Perjanjian yang mengikat antara Penyedia Aplikasi dan Pengguna Aplikasi
      untuk penggunaan layanan masjed.id, yang dilindungi oleh hukum yang
      berlaku di negara Republik Indonesia. Jika Anda tidak setuju dengan
      Perjanjian ini, klik "Batal" dan keluar dari aplikasi. Jika Anda mengklik
      "OK", maka Anda menjadi "User/Pengguna Aplikasi" untuk masjed.id dan
      menyetujui Kebijakan Privasi sebagai berikut :
    </p>
    <div>
      <ol>
        <li>
          "Informasi Pribadi" merujuk kepada seluruh dan setiap informasi yang
          diberikan oleh Anda selaku Pengguna Aplikasi kepada Penyedia Aplikasi
          sebagai pemenuhan syarat atas pemanfaatan fasilitas, fitur, jasa,
          dan/atau layanan aplikasi, maupun yang diperoleh pada saat Anda
          mengakses atau menggunakan aplikasi, yaitu :
          <ol>
            <li>
              Semua data yang Anda masukkan dalam aplikasi seperti : nama,
              alamat, alamat email, nomor telepon seluler, Internet Protocol
              (IP) address, dan lain lain;
            </li>
            <li>
              Semua data atas penggunaan aplikasi seperti fitur favorit, lama
              berinteraksi dengan aplikasi, dan lain lain;
            </li>
            <li>
              Semua data yang terkait dengan perangkat (device) seperti merek,
              model, sistem operasi yang digunakan, dan lain lain; dan
            </li>
            <li>Semua data yang terkait dengan lokasi Anda.</li>
          </ol>
        </li>
        <li>
          Penyedia Aplikasi berkewajiban untuk menjaga kerahasiaan informasi
          pribadi yang tidak dapat ditampilkan dalam aplikasi dan/atau diberikan
          kepada pihak tertentu, kecuali untuk informasi yang sifatnya sudah
          diketahui oleh umum berdasarkan ketentuan perundang-undangan yang
          telah ada sebelum perjanjian ini dibuat, atau informasi yang
          diperintahkan dibuka oleh aparat penegak hukum yang berwenang maupun
          kekuasaan pengadilan.
        </li>
        <li>
          Penyedia Aplikasi dapat menggunakan informasi pribadi hanya untuk
          tujuan sebagai berikut:
          <ol>
            <li>
              Menjaga performa aplikasi serta menangani kerusakan dan malfungsi
              Layanan;
            </li>
            <li>
              Mengembangkan aplikasi termasuk perbaikan fitur dan konten demi
              pengalaman menggunakan aplikasi yang lebih baik;
            </li>
            <li>
              Melakukan riset dan Analisa terhadap aplikasi, termasuk fitur dan
              konten yang ada di dalamnya;
            </li>
            <li>
              Mengirimkan materi pemasaran dan periklanan melalui pesan email,
              dengan permintaan persetujuan dari Pengguna Aplikasi terlebih
              dahulu. Kapanpun Anda dapat memilih keluar dari milis layanan,
              dengan mengubah preferensi di akun pribadi Anda. Penyedia Aplikasi
              tidak akan membagikan data pribadi Anda dengan mudah, tanpa adanya
              persetujuan tertulis dari Anda;
            </li>
            <li>Melakukan survei dan meminta kuisioner;</li>
            <li>Menerapkan Syarat dan Ketentuan Layanan;</li>
            <li>
              Mengungkapkan informasi Anda kepada aparat yang berwenang dalam
              rangka penegakan hukum;
            </li>
            <li>
              Mencegah kecurangan, penyalahgunaan, pelanggaran, pencurian
              identitas, penyalahgunaan layanan dan aktivitas ilegal lainnya;
            </li>
            <li>
              Melakukan tindakan yang diperlukan dalam suatu kasus,
              perselisihan, atau proses hukum apapun antara Pengguna dan
              Penyedia Aplikasi, atau antara Pengguna Aplikasi dengan pihak
              ketiga sehubungan dengan Layanan aplikasi ini;
            </li>
            <li>
              Penyedia Aplikasi juga dapat berbagi informasi pribadi dengan
              perusahaan lain atau pihak ketiga yang terhubung atau berafiliasi
              dengan Penyedia Aplikasi, dengan ketentuan yang menyatakan bahwa
              penggunaan informasi tersebut harus sesuai dengan yang dimaksud
              dalam kebijakan privasi ini.
            </li>
          </ol>
        </li>
        <li>
          Aplikasi dapat memuat tautan ke halaman situs lain yang disediakan
          oleh pihak ketiga yang ketentuan kerahasiaannya mungkin berbeda dengan
          aplikasi ini. Kami tidak membuat atau mendukung pernyataan apapun
          tentang halaman situs pihak ketiga tersebut dan tidak akan bertanggung
          jawab atas aturan kerahasiaan maupun isi dari halaman situs tersebut,
          bahkan apabila hal tersebut terlihat serupa seperti bagian dari
          aplikasi ini. Informasi Pribadi yang Anda pilih untuk disediakan atau
          yang dikumpulkan oleh pihak ketiga tidak termasuk dalam Kebijakan
          Privasi ini. Apabila Anda menghubungi atau mengunjungi halaman situs
          pihak ketiga tersebut, mohon memeriksa kembali Kebijakan Privasi
          mereka.
        </li>
        <li>
          Penyedia Aplikasi tidak bertanggung jawab atas kehillangan informasi
          pribadi, kerusakan aplikasi, kerusakan sistem perangkat, serta biaya,
          kuota, dan beban lain yang mungkin timbul sebagai akibat dari
          penggunaan aplikasi ini, termasuk sebagai akibat dari aktivitas Anda
          terkait penggunaan tautan ke halaman situs lain yang disediakan oleh
          pihak ketiga, baik secara langsung atau tidak langsung.
        </li>
        <li>
          Penyedia Aplikasi berupaya memberikan kepada Anda pengalaman terbaik
          pada saat menggunakan aplikasi ini, namun Penyedia Aplikasi tidak
          memiliki control atas perilaku Pengguna Aplikasi manapun dan tidak
          bertanggung jawab atas seluruh tindakan yang dilakukan Pengguna di
          luar ketentuan Layanan yang telah diatur. Penyedia Aplikasi disarankan
          untuk benar-benar memahami ketentuan Layanan yang telah diatur
          sehingga dengan demikian bertanggung jawab atas setiap resiko
          penggunaan layanan ini, baik langsung atau tidak langsung.
        </li>
        <li>
          Pengguna Aplikasi bertanggung jawab untuk mematuhi seluruh ketentuan
          hukum yang berlaku di negara Republik Indonesia, termasuk hukum di
          luar negeri yang berlaku di tempat domisili Pengguna Aplikasi, sejauh
          itu berkaitan dengan tujuan perlindungan terhadap kepentingan aplikasi
          dan Penyedia Aplikasi ini.
        </li>
        <li>
          Keamanan informasi adalah prioritas utama yang akan dilindungi oleh
          Penyedia Aplikasi, dengan tujuan implementasi sistem, aplikasi dan
          prosedur untuk mengamankan informasi pribadi, untuk meminimalkan
          resiko pencurian, kerusakan, kehilangan informasi, atau akses yang
          tidak sah atau penggunaan informasi. Namun, meskipun Penyedia Aplikasi
          berusaha keras untuk melindungi informasi pribadi Anda, Penyedia
          Aplikasi tidak sepenuhnya memberikan perlindungan secara mutlak. Oleh
          karena itu, Penyedia Aplikasi tidak dapat menjamin bahwa basis data
          dalam aplikasi ini akan kebal dari segala kesalahan, malfungsi,
          penyadapan atau akses yang tidak sah, atau jenis penyalahgunaan
          tindakan lainnya di luar jangkauan Penyedia Aplikasi.
        </li>
        <li>
          Penyedia Aplikasi berhak dari waktu ke waktu atas kebijakannya sendiri
          melakukan pembaharuan atas ketentuan-ketentuan yang terdapat dalam
          Kebijakan Privasi ini.
        </li>
        <li>
          Dengan membaca dan menerima "Perjanjian" ini, Pengguna Aplikasi juga
          menyetujui setiap pembaharuan yang dianggap perlu dilakukan oleh
          Penyedia Aplikasi terhadap layanan aplikasi ini di masa yang akan
          datang, meskipun tanpa memberikan pemberitahuan terlebih dahulu kepada
          Pengguna. Kecuali dinyatakan sebaliknya secara eksplisit, maka seluruh
          ketentuan yang terdapat dalam Kebijakan Privasi ini berlaku pula untuk
          setiap pembaharuan sebagaimana dimaksud, termasuk pada saat
          diluncurkannya versi yang baru dari aplikasi ini.
        </li>
        <li>
          Dengan menggunakan masjed.id maka Pengguna Aplikasi menyetujui dan
          terikat dengan syarat dan ketentuan yang berlaku dalam aplikasi ini.
        </li>
        <li>
          Hak Cipta – Pengguna Aplikasi tidak diperbolehkan melakukan
          penggadaan, penjualan, penyaluran, dan melakukan produksi ulang
          aplikasi dengan cara decompile (mendekompilasi) atau pun metode
          reverse engineering (rekayasa terbalik) lainnya secara sengaja baik
          sebagian aplikasi maupun keseluruhan.
        </li>
        <li>
          Data Pribadi – Data yang diberikan oleh para Pengguna Aplikasi kepada
          Penyedia Aplikasi sebagai pemenuhan syarat atas pemanfaatan fitur dan
          fasilitas yang ditawarkan Penyedia Aplikasi. Data-data tersebut adalah
          :
          <ol>
            <li>
              Semua data yang anda masukkan di aplikasi seperti nama, alamat,
              email, nomor telepon seluler, dan lain-lain;
            </li>
            <li>
              Semua data atas penggunaan aplikasi seperti fitur favorit, lama
              berinteraksi dengan aplikasi, dan lain-lain;
            </li>
            <li>
              Semua data yang terkait dengan device merek, model, sistem operasi
              yang digunakan, dan lain-lain;
            </li>
            <li>Semua data yang terkait dengan lokasi.</li>
          </ol>
          Maka PT MASJED INDONESIA DIGITAL sebagai Penyedia Aplikasi
          berkewajiban untuk :
          <ol>
            <li>
              Menjaga kerahasiaan data-data Pengguna Aplikasi yang tidak dapat
              ditampilkan dalam aplikasi dan/atau diberikan kepada pihak
              tertentu;
            </li>
            <li>
              Kerahasiaan data Pengguna Aplikasi yang wajib dijaga oleh Penyedia
              Aplikasi menjadi tidak berlaku apabila Penyedia Aplikasi dipaksa
              oleh ketentuan hukum yang berlaku, perintah pengadilan, dan/atau
              perintah aparat yang berwenang untuk membuka data Pengguna
              Aplikasi.
            </li>
          </ol>
        </li>
        <li>
          Penggunaan Data Pribadi – Data dan Informasi Pengguna Aplikasi hanya
          akan digunakan oleh Penyedia Aplikasi untuk tujuan :
          <ol>
            <li>Menjaga performa aplikasi;</li>
            <li>
              Melakukan perkembangan maupun perbaikan fitur demi pengalaman
              menggunakan aplikasi yang lebih baik; dan
            </li>
            <li>
              Melakukan riset dan Analisa terhadap aplikasi (fitur dan konten
              yang ada di dalamnya)
            </li>
          </ol>
        </li>
        <li>
          Content – isi content yang digunakan dalam beberapa fitur di aplikasi
          ini adalah dari pihak ketiga, jika ada ketidaksesuaian maupun
          kekurangan data bukan menjadi tanggung jawab masjed.id.
        </li>
        <li>
          Transaksi - segala transaksi yang dilakukan di masjed.id menggunakan
          jasa Payment Gateway yang keamanannya terjamin oleh standar keamanan
          internasional dan sudah mendapatkan ijin/license sesuai dengan
          peraturan pemerintah di Indonesia.
        </li>
        <li>
          Saldo DompetMU – fitur pencatatan dana milik para pengguna aplikasi
          masjed.id sebagai fasilitas penyimpanan dana ataupun uang elektronik
          yang bisa memberikan informasi dana transaksi Layanan dan/Biaya
          Layanan yang digunakan oleh para pengguna aplikasi melalui aplikasi
          masjed.id. Saldo DompetMU berasal dari penambahan atau Top Up secara
          mandiri yang dilakukan oleh para pengguna aplikasi masjed.id
        </li>
        <li>
          Saldo Infaq - fitur pencatatan dana milik Masjed yang dikelola oleh
          relawan masjed sebagai fasilitas penyimpanan dana donasi dari para
          donatur. Saldo infaq ini dapat digunakan/dilakukan pencairan dana
          (withdrawal/settlement) ke rekening bank sebagaimana yang telah
          ditentukan oleh relawan masjed. Atas pengelolaan pencatatan Saldo
          Infaq, aplikasi masjed.id hanya bertindak sebagai perantara Masjid dan
          Donatur yang berdonasi untuk masjid.
        </li>
      </ol>
    </div>
    <h5>Disclaimer aplikasi masjed.id</h5>
    <p>
      Aplikasi masjed.id adalah sebuah aplikasi di bawah naungan PT MASJED
      INDONESIA DIGITAL (Penyedia Aplikasi) yang bergerak di bidang layanan
      sosial berbasis teknologi. Aplikasi masjed.id hadir untuk memudahkan dalam
      pengelolaan manajemen masjed dan manajemen ZISWAF dalam upaya pemberdayaan
      ekonomi dan layanan kepada masyarakat di lingkungan masjed. Selain itu,
      aplikasi masjed.id menghadirkan banyak fitur bermanfaat, guna memudahkan
      dalam pembuatan laporan pertanggungjawaban keuangan masjed, memperluas
      jaringan donasi dan kampanye pendanaan melalui fitur Pembayaran secara
      online, sehingga masjed mendapatkan santunan penyaluran Zakat, Infaq,
      Sedekah, dan Wakaf yang dapat dirasakan langsung oleh masyarakat yang
      membutuhkan melalui fitur Daftarkan Dhuafa. Selain itu masjed.id mendorong
      kegiatan pemberdayaan ekonomi melalui kegiatan usaha serambi masjed, yang
      dapat membantu meningkatkan kesejahteraan pengurus masjed dan
      lingkungannya. Dengan menggunakan masjed.id maka Anda menyetujui dan
      terikat dengan Syarat dan Ketentuan yang berlaku dalam aplikasi ini.
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
div,
ul,
p,
ol,
li {
  text-align: justify;
}

ol {
  li {
    padding: 5px 0px;
  }
}
</style>
